var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',[_vm._v("Minu kandideerimised")])]},proxy:true}])},[_c('JobapplicationItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }